import React, { useState, Context, ReactElement, Component } from 'react';
import Cookies from 'universal-cookie';
import { datacenter_url } from '../../../worker/function/interfaces';

export interface top_navbar_type {
  lang: string;
  is_public: number;
  env?: datacenter_url;
  user_info?: IUserInfoType;
  datacenter_name?: string;
  unit?: string;
  subscriptions?: user_subscription[];
  subscription_id?: string;
  table_list_array?: { [key: string]: (value: any) => void };
}

export interface IUserInfoType {
  address: string;
  alternative_email: string;
  avatar: string;
  city: string;
  code?: number;
  company: string;
  contact_phone: string;
  country: string;
  creation_time: number;
  creator: string;
  expiration_time: number;
  first_name: string;
  groups: string[];
  id: string;
  industry: string;
  lastCity: string;
  lastIp: string;
  lastLat: number;
  lastLong: number;
  lastModifiedPwdTime: number;
  lastModifiedTime: number;
  lastName: string;
  lastSignedInTime: number;
  mobilePhone: string;
  officePhone: string;
  origin: string;
  postalCode: string;
  role: string;
  roles: any[];
  salt: string;
  signedInFrequencyCounter: number;
  status: string;
  username: string;
  userSubscriptions: user_subscription[];
  watchOnly: boolean;
  ssoRole: string;

  subscription_id: string;
  is_globaladmin: number;
  is_datacenteradmin: number;
  is_namespacedeveloper: number;
  has_namespacedeveloper: number;

  is_mp_lite: number;
}

export interface user_subscription {
  id: string;
  name: string;
  subscription_role: string;
  cluster_type: string;
  company: string;
}

export interface datacenter {
  data: {
    id: number;
    datacenterCode: string;
    datacenterName: string;
    datacenterUrl: datacenter_url;
    availableTime: string;
  }[];
  error: string;
  path: string;
  status: number;
  timestamp: string;
  totalCount: number;
  code: number;
  kind: string;
  index: number;
}

const cookies = new Cookies();

export const set_lang_cookie = (language: string): void => {
  const result = window.location.hostname.match(/(\.\w+\.wise-paas.*)/);
  if (Array.isArray(result)) {
    const domain = result[1].substr(1);
    cookies.set('lang', language, { domain: domain, path: '/', maxAge: 31536000 });
  }
};

const TopNavbarContext: Context<[top_navbar_type, React.Dispatch<React.SetStateAction<top_navbar_type>>]> = React.createContext<
  [top_navbar_type, React.Dispatch<React.SetStateAction<top_navbar_type>>]
>([{} as top_navbar_type, (_value: any) => {}]);

const TopNavbarProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [top_navbar, set_top_navbar]: [top_navbar_type, React.Dispatch<React.SetStateAction<top_navbar_type>>] = useState({
    lang: (() => {
      const cookie_lang = cookies.get('lang');
      !cookie_lang && set_lang_cookie('en-US');
      return cookie_lang || 'en-US';
    })(),
    is_public: 0
  });

  return <TopNavbarContext.Provider value={[top_navbar, set_top_navbar]}>{props.children}</TopNavbarContext.Provider>;
};

export { TopNavbarContext, TopNavbarProvider };
